import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { styles } from "./styles";

const STEPS = [
  {
    number: "1",
    title: "Book a demo",
    description:
      "Tell us about your programs, your cohorts, and how you teach today.",
  },
  {
    number: "2",
    title: "We set you up",
    description:
      "We create your organization's workspace, onboard your instructors and students, and publish your course pages.",
  },
  {
    number: "3",
    title: "Teach and grow",
    description:
      "Run live classes with built-in video, scheduling, payments, and messaging, while you focus on teaching.",
  },
];

const HowItWorksSection = () => {
  return (
    <Box sx={styles.sectionAlt}>
      <Container maxWidth="lg">
        <Typography component="h2" sx={styles.sectionTitle}>
          Launch in three steps
        </Typography>
        <Grid container spacing={4} mt={4}>
          {STEPS.map(({ number, title, description }) => (
            <Grid key={number} xs={12} md={4}>
              <Box sx={styles.stepNumberCircle}>{number}</Box>
              <Typography sx={styles.stepTitle}>{title}</Typography>
              <Typography sx={styles.stepDescription}>{description}</Typography>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorksSection;
